import { CHANGE_TEACHINGMODE } from "./type";

export const changeTeachingMode =
  (teachType, callback) => async (dispatch, getStore) => {
    dispatch({ type: CHANGE_TEACHINGMODE, payload: teachType });
    if (callback) callback();
  };
